export default [
  {
    name: 'Mama',
    value: 'G_MOTHER'
  },
  {
    name: 'Tata',
    value: 'G_FATHER'
  },
  {
    name: 'Opiekun prawny',
    value: 'G_GUARDIAN'
  }
];
